import Box from '@app/components/common/Box';
import Icon from '@app/components/common/Icon';
import Typography from '@app/components/common/Typography';
import { IDashboardGridStackElement } from '@app/state/home/types';
import Spinner from '@app/components/common/Spinner';
import Skeleton from '@app/components/common/Skeleton';
import { dashboardEmptyStyles } from '@app/components/LoggedIn/Home/DashboardCreator/DashboardEmpty/styles';

interface ICustomReportEmpty {
  elements: IDashboardGridStackElement[];
  enableEdit?: boolean;
  isLoading: boolean;
  pageSize: number;
}
const CustomReportEmpty = (props: ICustomReportEmpty) => {
  if (!(Object.values(props.elements).length === 0)) return null;

  return (
    <>
      <Box
        id="dashboardEmpty"
        csx={[
          dashboardEmptyStyles,
          { height: `${props.pageSize - 5}px`, top: '2px' },
        ]}>
        {Object.values(props.elements).length === 0 && (
          <Box className="customReportsEmptyBackdrop" />
        )}
        {props.isLoading && !props.enableEdit && props.elements.length === 0 ? (
          <Skeleton className="emptyLoading">
            <Spinner color="darkGrey" size="60px" />
            <Typography>Loading Custom Report...</Typography>
          </Skeleton>
        ) : (
          Object.values(props.elements).length === 0 && (
            <Box className="emptyMessage">
              <Icon name="MdDashboard" size="50px" />
              <Typography fontWeight="medium" variant="subtitle">
                Custom Report is empty
              </Typography>
              {props.enableEdit ? (
                <Typography color="darkGrey" variant="subtitle">
                  Start by adding some Widgets to your Custom Report
                </Typography>
              ) : (
                <Typography color="darkGrey" variant="subtitle">
                  You haven`&apos;`t added any Widgets to this Custom Report
                </Typography>
              )}
            </Box>
          )
        )}
      </Box>
    </>
  );
};

export default CustomReportEmpty;
